module.exports = __webpack_public_path__ + "static/kate-4987b988eec6fafba2b08922b19fe20e.jpg";